<script setup lang="ts">
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import ModalFromBot from './ModalFromBot.vue';
import { watch } from 'vue';
const isShowLanguageModal = ref<boolean>(false)
const langList = ref([
  { label: "English", value: "en_US" },
  { label: "繁體中文", value: "zh_TW" },
  { label: "日本語", value: "ja_JA" },
  { label: "한국어", value: "ko_KO" },
  { label: "ภาษาไทย", value: "th_TH" },
  { label: "Русский", value: "ru_RU" },
  { label: "Tiếng Việt", value: "vi_VN" },
]);
const { t, locale } = useI18n({ useScope: "global" });
const lang = ref<string>(locale.value);
const emit = defineEmits(["update:isShow"]);
const props = defineProps({
  isShow: Boolean,
});

const setLanguage = (data: string,index:number) => {
  lang.value = data
  locale.value = data;
  localStorage.setItem("starnest-locale", data);
  isShowLanguageModal.value = !isShowLanguageModal.value;
};

watch(()=>props.isShow,(val)=>{
  console.log(555);
  
  isShowLanguageModal.value = val
})

watch(()=>isShowLanguageModal.value,(val)=>{
  if (!val) {
    emit("update:isShow", false);
  }
})

</script>

<template>
  <ModalFromBot v-model:is-show="isShowLanguageModal">
      <div class="language-modal flex-col-center-center">
        <p class="title">{{t('Language Switch')}}</p>
        <div class="lang-list">
          <div
            class="lang-list-item flex-row-between-center"
            v-for="(item, index) in langList"
            :key="index"
            @click="()=>{
              setLanguage(item.value,index)
            }"
            :class="{ active: lang === item.value }"
          >
            <p class="flex-row-start-center">
              <span>{{ item.label }}</span>
            </p>
            <p class="check"></p>
          </div>
        </div>
      </div>
    </ModalFromBot>
</template>

<style lang="scss" scoped>
.language-modal{
  gap: 24px;
  padding: 24px 16px;
  .title {
    font-size: 18px;
    color: #fff;
    font-weight: 500;
  }
  .lang-list {
    width: 100%;
    &-item {
      width: 100%;
      height: 52px;
      font-size: 14px;
      font-weight: 500;
      color: #fff;
      &.active {
        .check {
          display: block;
        }
      }
      .check {
        display: none;
        width: 16px;
        height: 16px;
        background: url(../../assets/check.svg);
        background-repeat: no-repeat;
        background-size: contain;
      }
    }
  }
}
</style>
